import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import './assets/styles/defstyle.css'


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/element-reset.css'
Vue.use(ElementUI)

import axios from 'axios'
import qs from 'qs'
Vue.prototype.$axios = axios // 全局注册，使用方法为:this.$axios
Vue.prototype.$qs = qs // 全局注册，使用方法为:this.$qs

import common from "./def_common.js"
Vue.prototype.$common = common // 全局注册，使用方法为:this.$common

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts // 全局注册，使用方法为:this.$echarts

Vue.config.productionTip = false

//禁止选择网页中的文字（屏蔽鼠标事件，阻止鼠标事件，——鼠标选中网页文字）
// 20240725注释掉下方1行代码，取消原业务中限制鼠标限制鼠标右键功能
// document.onselectstart = function () { return false; }

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
